import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { CircleCheck, ClockIcon } from "../../../../assets/icons";
import { MySurveySummaryDTO } from "../../../../models/my-survey-summary/my-survey-summary-dto";
import CircleAndIconContainer from "../../reusable-widget-link-components/CircleAndIconContainer/CircleAndIconContainer";

const DraftLink = ({ customSummary, loading }: { customSummary: MySurveySummaryDTO; loading: boolean }) => {
  const tRP = "components.custom_widget_links.my_surveys.draft";
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <CircleAndIconContainer
      mainInfo={customSummary?.draft?.toString() ?? "0"}
      description={`${t(`${tRP}`)}`}
      Icon={customSummary?.draft > 0 ? ClockIcon : CircleCheck}
      IconStyle={{
        color: customSummary?.draft > 0 ? theme.palette.error.main : theme.palette.success.light,
        width: "90%",
        height: "90%",
      }}
      loading={loading}
      {...(customSummary?.draft > 0 && {
        animateIcon: true,
      })}
    />
  );
};
export default DraftLink;
